import 'is-in-viewport';

const animateInViewportClasses = [
	'move-up-in-viewport',
	'move-down-in-viewport',
	'move-left-in-viewport',
	'move-right-in-viewport',
	'fade-in-in-viewport',
	'zoom-in-in-viewport',
	'active-in-viewport',
	'full-width-in-viewport',
	'animate-in-in-viewport',
	'slide-in-in-viewport',
	'fade-out-in-viewport',
];

$( function() {
	animateInViewport();

	$( 'html' ).addClass( 'fade-in' );

	$( 'a' ).filter( function() {
		const href = $( this ).attr( 'href' );
		return href &&
			!href.startsWith( '#' ) &&
			$( this ).attr( 'target' ) !== '_blank' &&
			href.startsWith( window.location.origin );
	} ).on( 'click', function( event ) {
		event.preventDefault();
		goToHref( this.href );
	} );
} );

$( window ).on( 'load', function() {
	animateInViewport();
} );

export function goToHref( href ) {
	$( 'html' ).addClass( 'fade-out' );

	setTimeout( function() {
		window.location.href = href;
	}, 1 );
}

function debounce( func, wait ) {
	let timeout;
	return function( ...args ) {
		const context = this;
		clearTimeout( timeout );
		timeout = setTimeout( () => func.apply( context, args ), wait );
	};
}

const debouncedAnimate = debounce( animateInViewport, 5 );

$( window ).scroll( function() {
	debouncedAnimate();
} );

export function animateInViewport() {
	$( animateInViewportClasses.map( cls => `.${cls}` ).join( ',' ) ).filter( ':not(.wait-to-animate)' ).each( function() {
		const $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );
		}
	} );
}
